const Images={
    play:"/images/play.png",
    job:"/images/job.png",
    vote:"/images/vote.png",
    email:"/images/email.png",
    rent:"/images/rent.png",
    health:"/images/health.png",
    sports:"/images/sports.png",
    discount:"/images/discount.png",
    contact:"/images/contact.png",
    bulk:"/images/bulk.png",
    hero:"/images/hero.png",
    about:"/images/about.png",
    telecel:"/images/telecel.png",
    at:"/images/at.png",
    graphic:"/images/graphic.png",
    nalo:"/images/nalo.png",
    logo:"/images/quicklogo.png",
    bulk1:"/images/Bulk1.png",
    woman:"/images/woman.png",
    ussd:"/images/ussd.png",
    email1:"/images/email1.png",
    voiceb:"/images/voiceb.jpg",
    emailb:"/images/emailb.jpg",
    voteb:"/images/voteb.jpg",
    playb:"/images/playb.jpg",
    bulkb:"/images/bulkb.jpg",
    voices:"/images/voices.jpg",
    plays:"/images/plays.jpg",
    bulks:"/images/bulks.jpg",
    votes:"/images/votes.jpg",
    emails:"/images/emails.jpg",
    PrinceBruceOtoo:"/images/PrinceBruceOtoo.jpg",
    GeorgeBruceOtoo:"/images/GeorgeBruceOtoo.jpg",
    JulianaAgyeiwaaAsare:"/images/JulianaAgyeiwaaAsare.jpg",
    DanielAvorwulanu:"/images/DanielAvorwulanu.png",
    EugeneOpokuAsante:"/images/EugeneOpokuAsante.jpg",



}
export default Images;